import { Design, Mask, SharingDraftMaskSettings } from '@/types';
import { clamp } from '@/utils/math/clamp';
import { DESIGN_MIN_SIZE, MASK_VERSION } from './constants';
import { initMaskImage } from './initMaskImage';

export async function updateMaskVersion(
  maskConfiguration: SharingDraftMaskSettings,
  mask: Mask,
  { size: { width, height } }: Design
) {
  const { naturalWidth, naturalHeight } = await initMaskImage(mask);

  const [previewWidth, previewHeight] =
    width > height
      ? [DESIGN_MIN_SIZE, (DESIGN_MIN_SIZE / width) * height]
      : [(DESIGN_MIN_SIZE / height) * width, DESIGN_MIN_SIZE];

  const { scale: oldScale, offset: oldOffset } = maskConfiguration;
  const oldMaskWidth = oldScale.x * naturalWidth;
  const oldMaskHeight = oldScale.y * naturalHeight;

  const scaleX = clamp(oldMaskWidth / previewWidth);
  const scaleY = clamp(oldMaskHeight / previewHeight);

  const scale = {
    x: scaleX,
    y: scaleY,
  };
  const offset = {
    x: scaleX === 1 ? 0.5 : clamp(oldOffset.x / (previewWidth - oldMaskWidth)),
    y: scaleY === 1 ? 0.5 : clamp(oldOffset.y / (previewHeight - oldMaskHeight)),
  };

  return {
    ...maskConfiguration,
    scale,
    offset,
    version: MASK_VERSION,
  };
}
